import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * GtmRouteTracker — pushes a virtual pageview to dataLayer on every SPA route change.
 *
 * Without this, GTM's built-in History Change trigger fires inconsistently on
 * pushState navigations, so GA4 / Google Ads / Meta Pixel page_view tags
 * configured inside the GTM container would only fire on the initial load.
 *
 * The dataLayer push is GTM-safe — no third-party tags are loaded here.
 * Inside the GTM container, create a Custom Event trigger on event = "page_view"
 * (or use the {{Page Path}} variable) to fire your page_view tags.
 */
export default function GtmRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
